import { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../../Icons'
import { getProperTeamType, getProperTeamNameByType } from '../../helpers'
import { cutTooLong } from '../../../../helpers/helpers'
import { getAssetLink } from '../../../../helpers/get-asset-link'

const AssigneeSelector = ({ options, selectedId, onChange, disabled }) => {
  const { t } = useTranslation(['chat'])
  const wrapperRef = useRef(null)
  const [isOpen, setOpen] = useState(false)

  const selectOption = (e, value) => {
    onChange(value.id)
    setOpen(false)
  }

  const handleClickOutside = (event) => {
    if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
      setOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const selectedUser = selectedId
    ? options.find((el) => Number(el.id) === Number(selectedId))
    : null

  return (
    <div className={`assignee-container ${disabled ? 'loading' : ''}`}>
      <div className="selected-assignee" onClick={() => setOpen(!isOpen)}>
        <div className="assigned-user-data">
          {selectedUser ? (
            <img src={getAssetLink({ path: 'chitown-avatar/avatar', file: selectedUser.avatar })} />
          ) : null}
          {selectedUser
            ? `${cutTooLong(`${selectedUser.firstName} ${selectedUser.lastName}`, 16)}`
            : t('chat:assigneeSelector.unassigned')}
        </div>
        <Icon icon={'arrow'} />
      </div>
      {isOpen ? (
        <div className={`field-select__dropdown`} ref={wrapperRef}>
          {options.length > 0 &&
            options.map((option) => {
              return (
                <div
                  className="dropdown-container"
                  onClick={(e) => selectOption(e, option)}
                  key={option.id}
                >
                  <div className="avatar-container">
                    <img
                      src={getAssetLink({ path: 'chitown-avatar/avatar', file: option.avatar })}
                    />
                  </div>
                  <div className="assigne-info-container">
                    <div className="name">
                      {cutTooLong(`${option.firstName} ${option.lastName}`, 25)}
                    </div>
                    <div className="role-team">
                      {getProperTeamNameByType(getProperTeamType(option.role))}
                    </div>
                  </div>
                </div>
              )
            })}
        </div>
      ) : null}
    </div>
  )
}

AssigneeSelector.propTypes = {
  options: PropTypes.array,
  selectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
}

export default AssigneeSelector
